// @vendors
const React = require('react');
const PropTypes = require('prop-types');

class RAToggle extends React.Component {
    render() {
        return this.props.showRobo ? this.props.children : null;
    }
}

RAToggle.propTypes = {
    children: PropTypes.element.isRequired,
    showRobo: PropTypes.bool,
};

module.exports = RAToggle;
